module.exports = __webpack_public_path__ + "img/Graph2_30days_red.97441af4.png";